import React from 'react';
import {
  Paper,
  BottomNavigation,
  BottomNavigationAction,
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  LocalHospital as DiseaseIcon,
  MedicalServices as TreatmentIcon,
  ModelTraining as TrainingSampleIcon,
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';

export const MobileBottomNav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { text: 'Dashboard', icon: <DashboardIcon />, path: '/', value: 'dashboard' },
    { text: 'Diseases', icon: <DiseaseIcon />, path: '/diseases', value: 'diseases' },
    { text: 'Treatments', icon: <TreatmentIcon />, path: '/treatments', value: 'treatments' },
    { text: 'Training', icon: <TrainingSampleIcon />, path: '/training-samples', value: 'training' },
  ];

  const getCurrentNavValue = () => {
    const currentItem = menuItems.find(item => item.path === location.pathname);
    return currentItem?.value || 'dashboard';
  };

  return (
    <Paper
      sx={{ 
        position: 'fixed', 
        bottom: 0, 
        left: 0, 
        right: 0, 
        zIndex: 1000,
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        borderTop: '1px solid rgba(0,0,0,0.08)',
        boxShadow: '0 -4px 24px rgba(0,0,0,0.08)',
      }}
      elevation={0}
    >
      <BottomNavigation
        value={getCurrentNavValue()}
        onChange={(_, newValue) => {
          const item = menuItems.find(item => item.value === newValue);
          if (item) {
            navigate(item.path);
          }
        }}
        showLabels
        sx={{
          backgroundColor: 'transparent',
          '& .MuiBottomNavigationAction-root': {
            color: 'text.secondary',
            '&.Mui-selected': {
              color: 'primary.main',
            },
            '& .MuiBottomNavigationAction-label': {
              fontSize: 12,
              fontWeight: 500,
            },
          },
        }}
      >
        {menuItems.map((item) => (
          <BottomNavigationAction
            key={item.value}
            label={item.text}
            value={item.value}
            icon={item.icon}
          />
        ))}
      </BottomNavigation>
    </Paper>
  );
};